<!-- Dropdown -->
<div *ngIf="subscriptionId > 0 && subscriptionDetails.status.toLowerCase() !== 'void' && subscriptionDetails.status.toLowerCase() !== 'cancelled'" class="relative">
<p-button
    icon="fa fa-angle-down"
    [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
    iconPos="right"
    styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 p-2"
    (click)="subscriptionAction1.toggle($event)"
></p-button>
<p-button
    icon="fa fa-cog"
    styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 md:hidden"
    (click)="subscriptionAction1.toggle($event)"
></p-button>
<p-popover #subscriptionAction1 styleClass="overflow-hidden right-0 text-sm w-14rem">
    <ng-template #content>
        <ul *ngIf="subscriptionId > 0" class="list-none -m-4 py-2 px-0 text-xs text-600">
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="showVoidSubscription(subscriptionDetails)">
                <i class="fa fa-ban mr-2"></i>
                <span *ngIf="subscriptionDetails && subscriptionDetails.upgrade_from_clt_subs_id > 0">{{ 'ADMIN.COMMON.VOID_UPGRADE' | translate }}</span>
                <span *ngIf="subscriptionDetails && subscriptionDetails.upgrade_from_clt_subs_id === 0">{{ 'ADMIN.COMMON.VOID' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="showActiveMembershipBtn(subscriptionDetails.status)" (click)="ShowActivateMembership(subscriptionDetails)">
                <i class="fa fa-rotate mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_ACTIVATE_MEMB' | translate }}</span>
            </li>
            <li
                *ngIf="showFreeDiscountApply.value && showFreeDiscountAction && isRecurring && CanAddFreeDiscount(subscriptionDetails.status)"
                (click)="showFreeDiscount(subscriptionDetails)"
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
            >
                <i class="fa fa-percent mr-2"></i>
                <span>{{ 'FREEDISCOUNT.BTN_ADD_DISCOUNT' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="showAddonBilling.value && isRecurring" (click)="ShowMidCycleAddon()">
                <i class="fa fa-plug mr-2"></i>
                <span>{{ 'BILLING_ADDONS.MID_CYCLE_ADDON' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="isNotRenewingStatus(subscriptionDetails.status)" (click)="ReActivateMembership(subscriptionDetails)">
                <i class="fa-solid fa-power-off mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_RE_ACTIVATE' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [ngClass]="{'pointer-events-none opacity-40': isPresaleTenant}" (click)="goToUpgrade()">
                <i class="fa fa-arrow-alt-circle-up mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_UPGRADE' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="isMinimumDateTimeValue(subscriptionDetails.scheduled_cancellation_date)" (click)="GoToCancel(subscriptionDetails)">
                <i class="fa-solid fa-power-off mr-2"></i>
                <span>{{ 'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate }}</span>
            </li>
            <li
                class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center"
                [ngClass]="{'pointer-events-none opacity-40': isPresaleTenant}"
                *ngIf="(subscriptionDetails.is_transferable || subscriptionDetails.transferable) && showTransfer.value"
                (click)="goToTransfer()"
            >
                <i class="fa fa-exchange-alt mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_TRANSFER' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" [ngClass]="{'pointer-events-none opacity-40': isPresaleTenant}" *ngIf="!IsSubscrptionVoidOrCancelled(subscriptionDetails.status)" (click)="goToFreeze()">
                <i class="fa fa-pause mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.BTN_FREEZE' | translate }}</span>
            </li>
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" *ngIf="signupId > 0" (click)="VoidSignUp()">
                <i class="fa fa-ban mr-2"></i>
                <span>{{ 'common.BUTTONS.BTN_VOID_SIGNUP' | translate }}</span>
            </li>
            <li *ngIf="CanSendCollectionDuesLink(subscriptionDetails.status) && isRecurring" class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="SendLinkCollectDuesClick()">
                <i class="fa fa-link mr-2"></i>
                <span>{{ 'SUBSCRIPTIONS.SEND_MANAGE_LINK' | translate }}</span>
            </li>
        </ul>
    </ng-template>
</p-popover>
</div>

<!-- Dropdown -->


<div *ngIf="subscriptionId === 0" class="relative">
<p-button
    icon="fa fa-angle-down"
    [label]="'common.BUTTONS.BTN_ACTIONS' | translate"
    iconPos="right"
    styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 p-2"
    (click)="subscriptionAction2.toggle($event)"
></p-button>
<p-button
    icon="fa fa-cog"
    styleClass="text-sm text-600 p-button-outlined p-button-secondary border-300 md:hidden"
    (click)="subscriptionAction2.toggle($event)"
></p-button>
<p-popover #subscriptionAction2 styleClass="overflow-hidden right-0 text-sm w-14rem">
    <ng-template #content>
        <ul *ngIf="subscriptionId === 0" class="list-none -m-4 py-2 px-0 text-xs text-600">
            <li class="cursor-pointer hover:surface-300 py-2 px-3 flex align-items-center" (click)="VoidSignUp()">
                <i class="fa fa-ban mr-2"></i>
                <span>{{ 'common.BUTTONS.BTN_VOID_SIGNUP' | translate }}</span>
            </li>
        </ul>
    </ng-template>
</p-popover>
</div>



<!-- Dropdown -->



<!-- Void subscription Modal -->
<p-dialog [(visible)]="showVoidSubscriptionModal" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '630px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Content -->
        <form [formGroup]="voidSubscriptionForm">
            <div class="relative text-center p-4">
                <div class="fa fa-times text-xl opacity-50 absolute right-0 top-0 mt-3 mr-3 md:mt-4 md:mr-4 cursor-pointer" (click)="showVoidSubscriptionModal = false"></div>

                <img width="160" class="block mx-auto" src="/assets/img/void-invoice-img.svg" alt="Image" />

                <h4 class="text-base md:text-lg my-3 font-bold">
                    {{'SUBSCRIPTIONS.VOID_SUBSCRIPTION'| translate}} <br />
                    {{subscriptionDetails.name_primary_language || subscriptionDetails.name_secondary_language | titlecase}} ?
                </h4>
                <ul class="text-left text-sm mb-0" *ngIf="!upgradedSubscription">
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO1'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO2'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO3'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_SUBSCRIPTION_INFO4'| translate}}</li>
                </ul>
                <ul class="text-left text-sm mb-0" *ngIf="upgradedSubscription">
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO1'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO2'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO3'| translate}}</li>
                    <li class="my-1">{{'SUBSCRIPTIONS.VOID_UPGRADE_SUBSCRIPTION_INFO4'| translate}}</li>
                </ul>
            </div>
            <!-- Content -->

            <!-- Content -->
            <div class="surface-100 p-4">
                <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'INVOICE.REASON'| translate}}</label>
                <textarea pInputTextarea formControlName="void_reason" class="text-sm w-full h-5rem"></textarea>
                <app-error-msg *ngIf="VoidReasonFormControl.touched && VoidReasonFormControl.invalid" [errors]="VoidReasonFormControl.errors" [fieldLabel]="'INVOICE.REASON_REQUIRED' | translate"> </app-error-msg>
            </div>
            <!-- Content -->

            <!-- Modal Footer -->
            <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
                <button pButton pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" class="p-button-primary p-button-text text-sm" (click)="showVoidSubscriptionModal = false"></button>
                <button pButton pRipple type="button" [label]="'SUBSCRIPTIONS.BTN_VOID' | translate" class="p-button-danger text-sm" [loading]="btnLoading$ | async" (click)="voidSubscription(voidSubscriptionForm)"></button>
            </div>
            <!-- Modal Footer -->
        </form>

        <app-errors *ngIf="showErrorPopup | async as show_Popup" [visible]="show_Popup" [errorData]="errorMessages" [error]="error" (hideErrorPopup)="HideErrorPopup($event)"> </app-errors>
    </ng-template>
</p-dialog>
<!-- Void subscription Modal -->

<!-- Activate subscription Modal -->
<p-dialog [(visible)]="ActivateMembershipPopup" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <form [formGroup]="ActivateMebershipForm">
            <div class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
                <h4 class="text-base font-normal mb-0">{{ 'common.HEADERS.CONFIRM_ACTIVEATE_MEMB' | translate }}</h4>
                <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="ActivateMembershipPopup = false"></div>
                <!-- <span class="text-sm text-blue-600">{{ 'SUBSCRIPTIONS.ACTIVATE_INFO'  | translate }} </span> -->
            </div>
            <!-- Header -->

            <!-- Content -->
            <div class="surface-100 p-3">
                <div class="mb-3 -mt-3">
                    <p-message severity="info" icon="fa fa-exclamation-triangle" aria-label="activate-info-message" data-testid="activate-info-message">
                        {{'SUBSCRIPTIONS.ACTIVATE_INFO' | translate}}
                    </p-message>
                </div>
                <textarea pInputTextarea formControlName="change_reason" class="text-sm w-full h-5rem"></textarea>
                <app-error-msg *ngIf="ChangeReasonActiveFormControl.touched && ChangeReasonActiveFormControl.invalid" [errors]="ChangeReasonActiveFormControl.errors" [fieldLabel]="'SUBSCRIPTIONS.REASON' | translate"> </app-error-msg>
            </div>
            <!-- Content -->

            <!-- Modal Footer -->
            <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
                <div class="w-4"></div>
                <div class="w-8 text-right">
                    <p-confirmPopup key="activatemembership"></p-confirmPopup>
                    <button pButton pRipple type="button" [label]="'common.BUTTONS.BTN_CONFIRM' | translate" class="p-button-primary text-sm" (click)="ActivateConfirm($event)"></button>
                </div>
            </div>
            <!-- Modal Footer -->
        </form>

        <app-errors *ngIf="showErrorPopup | async as show_Popup" [visible]="show_Popup" [errorData]="errorMessages" [error]="error" (hideErrorPopup)="HideErrorPopup($event)"> </app-errors>
    </ng-template>
</p-dialog>
<!-- Activate subscription Modal -->

<p-dialog [(visible)]="voidSignUpPopup" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'767px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Header -->
        <form [formGroup]="VoidSubscriptionSignupForm">
            <div class="p-3 sticky w-full top-0 right-0 surface-0 z-1 flex align-items-center justify-content-between border-bottom-1 border-300">
                <h4 class="text-base font-normal mb-0">{{ 'common.HEADERS.CONFIRM_VOID_SIGNUP' | translate }}</h4>
                <div class="fa fa-times text-xl text-600 cursor-pointer" (click)="voidSignUpPopup = false;voidSignUpBtnLoading=false"></div>
                <!-- <span class="text-sm text-blue-600">{{ 'SUBSCRIPTIONS.ACTIVATE_INFO'  | translate }} </span> -->
            </div>
            <!-- Header -->
            <!-- Content -->
            <div class="surface-100 p-3">
                <div class="mb-3 -mt-3">
                    <p-message severity="info" icon="fa fa-exclamation-triangle" aria-label="signup-void-info-message" data-testid="signup-void-info-message">
                        {{'SUBSCRIPTIONS.SIGNUP_VOID_INFO' | translate}}
                    </p-message>
                </div>

                <label class="font-medium text-700 text-xs mb-2 block uppercase">{{'SUBSCRIPTIONS.REASON' | translate}}</label>
                <textarea pInputTextarea formControlName="void_reasons" class="text-sm w-full h-5rem"></textarea>
                <app-error-msg *ngIf="VoidSignupReasonFormControl.touched && VoidSignupReasonFormControl.invalid" [errors]="VoidSignupReasonFormControl.errors" [fieldLabel]="'SUBSCRIPTIONS.REASON' | translate"> </app-error-msg>
            </div>
            <!-- Content -->

            <!-- Modal Footer -->
            <div class="flex align-items-center justify-content-between px-4 py-3 border-top-1 border-300">
                <div class="w-4"></div>
                <div class="w-8 text-right">
                    <p-confirmPopup key="activatemembership"></p-confirmPopup>
                    <button pButton pRipple type="button" [label]="'common.BUTTONS.BTN_CONFIRM' | translate" class="p-button-primary text-sm" (click)="SubmitVoidSignup($event)"></button>
                </div>
            </div>
            <!-- Modal Footer -->
        </form>
        <app-errors *ngIf="showErrorPopup | async as show_Popup" [visible]="show_Popup" [errorData]="errorMessages" [error]="error" (hideErrorPopup)="HideErrorPopup($event)"> </app-errors>
    </ng-template>
</p-dialog>

<subscription-free-discount
    *ngIf="addDiscountedPeriod"
    [visible]="addDiscountedPeriod"
    [clientDetails]="clientDetails"
    [clientId]="clientId"
    [tenantId]="tenantId"
    [subscriptionId]="subscriptionId"
    [timelines]="paymentTimelineData"
    (closePopup)="closeFreeDiscountPopup($event)"
>
</subscription-free-discount>

<billing-add-on *ngIf="showAddonSidebar" [visible]="showAddonSidebar" [tenantId]="tenantId" [planId]="planId" [mode]="'midcycleaddon'" [selectedAddons]="selectedAddons" (closeAddonSidebar)="closeAddonSidebar($event)"> </billing-add-on>

<subscription-cancel *ngIf="showCancelSubscription" [visible]="showCancelSubscription" [clientId]="clientId" [tenantId]="tenantId" [subscription]="clientSubscriptionData | async" (closeEvent)="closeSubscriptionCancelEvent($event)">
</subscription-cancel>

<!-- Send Link - Collect Dues  -->
<p-dialog [(visible)]="sendLinkCollectDues" [resizable]="false" appendTo="body" [modal]="true" [breakpoints]="{'991px': '100vw'}" [style]="{width: '500px'}" styleClass="no-header-modal">
    <ng-template pTemplate="header" styleClass="hidden"></ng-template>
    <ng-template pTemplate="content" styleClass="p-0">
        <!-- Content -->
        <form [formGroup]="sendLinkCollectDuesForm">
            <!-- Modal Header -->
            <div class="p-3 flex align-items-center justify-content-between border-bottom-1 border-300">
                <h2 class="mb-0 text-sm">{{'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHEADER' | translate }}</h2>
                <i class="fa fa-times text-xl text-600 cursor-pointer" (click)="sendLinkCollectDues = false"></i>
            </div>
            <!-- Modal Header -->

            <div class="py-4 px-3">
                <p class="text-sm mb-5">{{'SUBSCRIPTIONS.COLLECTDUES_SENDLINKCOLLECTDUESHELP' | translate }}</p>

                <h4 class="text-sm text-600 mb-2 font-normal">{{'SUBSCRIPTIONS.COLLECTDUES_SENDON' | translate }}</h4>

                <div class="p-buttonset white-space-nowrap">
                    <button
                        [ngClass]="emailSelected ? 'p-button-primary' : 'p-button-secondary' "
                        (click)="emailSelected=!emailSelected"
                        class="p-button-primary border-right-1 text-sm border-white"
                        pButton
                        pRipple
                        label="{{'SUBSCRIPTIONS.COLLECTDUES_EMAIL' | translate }}"
                        icon="fa fa-envelope font-light"
                    ></button>
                    <button
                        [ngClass]="smsSelected ? 'p-button-primary' : 'p-button-secondary' "
                        (click)="smsSelected=!smsSelected"
                        class="p-button-primary border-right-1 text-sm border-white"
                        pButton
                        pRipple
                        label="{{'SUBSCRIPTIONS.COLLECTDUES_SMS' | translate }}"
                        icon="fa fa-comments font-light"
                    ></button>
                    <button
                        [ngClass]="whatsappSelected ? 'p-button-primary' : 'p-button-secondary' "
                        (click)="whatsappSelected=!whatsappSelected"
                        class="p-button-primary border-right-1 text-sm border-white"
                        pButton
                        pRipple
                        label="{{'SUBSCRIPTIONS.COLLECTDUES_WHATSAPP' | translate }}"
                        icon="fab fa-whatsapp"
                    ></button>
                </div>
            </div>

            <!-- Content -->

            <!-- Modal Footer -->
            <div class="p-3 border-top-1 border-300 flex align-items-center justify-content-between">
                <p-button pRipple type="button" [label]="'common.BUTTONS.CANCEL-BUTTON-TEXT' | translate" class="p-button-primary p-button-text text-sm" (click)="sendLinkCollectDues = false"> </p-button>

                <p-button pRipple type="button" [label]="'SUBSCRIPTIONS.BTN_SEND' | translate" (click)="funSendCollectDuesLink(sendLinkCollectDuesForm)" styleClass="text-sm"> </p-button>
            </div>
            <!-- Modal Footer -->
        </form>
    </ng-template>
</p-dialog>
<!-- Send Link - Collect Dues -->
